<template>
  <TopGradientBlockLayout>
    <template v-slot:top>
      <TicketSystemAdd/>
    </template>
    <TicketsSystemList v-if="activeTickets.data.length || closedTickets.data.length"
                       :active-tickets="activeTickets.data"
                       :closed-tickets="closedTickets.data"/>
    <TicketSystemListEmpty v-else-if="!activeTickets.dirty && !closedTickets.dirty"/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TicketSystemAdd from "@/components/cabinet/Tickets/TicketsSystem/TicketsSystemAdd";
import {mapActions, mapState} from "vuex";
import TicketsSystemList from "@/components/cabinet/Tickets/TicketsSystem/TicketSystemList/TicketsSystemList";
import TicketSystemListEmpty from "@/components/cabinet/Tickets/TicketsSystem/TicketSystemList/TicketsSystemListEmpty";

export default {
  name: "TheTicketsSystem",
  components: {TicketSystemListEmpty, TicketsSystemList, TicketSystemAdd, TopGradientBlockLayout},
  computed: {
    ...mapState('cabinet/tickets', ['activeTickets', 'closedTickets']),
  },
  mounted() {
    this.$store.dispatch('cabinet/tickets/fetchUserActiveTicketsList')
    this.$store.dispatch('cabinet/tickets/fetchUserClosedTicketsList')
  }
}
</script>